import React from 'react';

// Components
import Orders from 'components/Orders';

const OrdersStorePage = () => <Orders isAdmin={false} />;

export default OrdersStorePage;
